$(document)
  .on('click', '.arrow', function() {

    $('.arrow').toggleClass('collapsed')
    $('#packageForm .packages_wrapper').toggleClass('collapsed')

  })
